module.exports = __webpack_public_path__ + "img/75.cb1f13c.png";